import { createContext } from 'react';

export const GaugeChartLoadingContext = createContext<boolean>(false);
